import { MultiValueProps } from 'react-select';



const CustomMultiValue = (props: MultiValueProps) => <span className='custom-multi-value'>{props.children}</span>

export default CustomMultiValue